import { HTTPResponse, BaseResponseList } from '../models';
import { T } from './translation-keys';

export const DEFAULT_ERROR_RESPONSE: HTTPResponse<null> = {
  result: null,
  errorCode: null,
  errorMessage: T.SOMETHING_WENT_WRONG
};

export const DEFAULT_RESPONSE_LIST: BaseResponseList<any> = {
  count: 0,
  items: []
};

export const noop = () => void 0;

export const BEARER = 'Bearer';

export const PGCOIN = 'PG';

export const FTN = 'FTN';

export const NSP = 'NSP';

export const CCEuro24GameId = 24;
export const PascalPenaltyGameId = 356;
export const PixelRoadGameId = 345;
export const WildHuntGameId = 375;

export const PascalGodOfAtlantisGameId = 295;

export const PascalFortuneMasterGoatGameId = 278;

export const PascalFortunePotsGameId = 220;

export const PascalSugarBalloonGameId = 314;

export const GOOGLE_ANALYTICS_ID = "G-NYRZ35ZKZ0";

// Max 32-bit integer for setTimeout (~24.8 days)
export const MAX_TIMEOUT = 2147483647; 
export const TWO_HOURS_MS = 2 * 60 * 60 * 1000;
export const THIRTY_MINUTES_MS = 30 * 60 * 1000;
export const TWO_MINUTES_MS = 2 * 60 * 1000;
export const FIVE_MINUTES = 5 * 60 * 1000;
export const THREE_MINUTES_MS = 3 * 60 * 1000;
